import { AUTH_ERRORS, type PublicUser } from "@storyline/shared";
import { getApiErrorCode, getApiErrorMessage, unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";
import { setTokens } from "@/src/common/services/token-store.service";

export class AuthError extends Error {
	readonly code: string;

	constructor(code: string, message: string) {
		super(message);
		this.name = "AuthError";
		this.code = code;
	}
}

export type OtpRequestResult = {
	devCode: string | null;
};

export const requestOtp = async (email: string): Promise<OtpRequestResult> => {
	const { data, error } = await httpClient.auth.otp.request.post({ email });
	if (error || !data) {
		throw new AuthError(getApiErrorCode(error?.value) ?? AUTH_ERRORS.OTP_RATE_LIMITED.code, getApiErrorMessage(error?.value));
	}
	return { devCode: data.devCode };
};

export const verifyOtp = async (email: string, code: string): Promise<PublicUser> => {
	const { data, error } = await httpClient.auth.otp.verify.post({ email, code });
	if (error || !data) {
		throw new AuthError(getApiErrorCode(error?.value) ?? AUTH_ERRORS.INVALID_OTP.code, getApiErrorMessage(error?.value));
	}
	await setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken });
	return data.user;
};

export const getMe = async (): Promise<PublicUser> => unwrap(await request(() => httpClient.users.me.get()));

export const logout = async (refreshToken: string): Promise<void> => {
	await httpClient.auth.logout.post({ refreshToken });
};
